// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_76-6";
export var headerCell = "_76-2";
export var rowWrapper = "_76-4";
export var stickyAggregationCell = "_76-a";
export var stickyAggregationRow = "_76-7";
export var stickyColumnCell = "_76-9";
export var stickyColumnHeaderCell = "_76-8";
export var table = "_76-1";
export var virtualRowWrapper = "_76-5";
export var virtualTableContainer = "_76-0";
export var white = "_76-3";